
















































































import Market from '@core/models/offer/Market';
import {
    defineComponent,
    PropType,
    computed,
} from '@vue/composition-api';
import EventCardLabel from './EventCardLabel.vue';
import EventPin from './EventPin.vue';
import {
    isMobileLayout,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import OddButton from '@shared/event/OddButton.vue';
import { BetslipStore } from '@store/modules/ui/betSlip';
import { PE131DescriptiveOddNameVariant } from '@core/models/user/flags';
import { getPe131DescriptiveOddButtonVariant } from '@app/shared/featureFlags/pe131DescriptiveOddButtonFlag';

export default defineComponent({
    name: 'OddOffer',
    emits: [
        'oddClick',
        'pinClick',
    ],
    props: {
        marketCount: {
            type: Number,
            default: 0,
        },
        moreOdds: {
            type: Number,
            default: 0,
        },
        market: {
            type: Object as PropType<Market | null>,
            default: null,
        },
        expandedEvent: {
            type: Number,
            default: null,
        },
        isEventLocked: {
            type: Boolean,
            default: false,
        },
        selectedOdds: {
            type: Set as PropType<Set<string>>,
            required: true,
        },
        oddValueDynamics: {
            type: Object,
            required: false,
            default: undefined,
        },
        isPrimaryMarketSelected: {
            type: Boolean,
            default: true,
        },
        isPinShown: {
            type: Boolean,
            required: true,
        },
        isEventPinned: {
            type: Boolean,
            required: false,
            default: false,
        },
        hideMarkerHeader: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    setup(props) {
        const betslipStore = useVuexStore<BetslipStore>('ui/sportOffer/betSlip');
        const applyOddButtonOverrideStyle = getPe131DescriptiveOddButtonVariant() !== PE131DescriptiveOddNameVariant.None;

        const hasSelectionInCollapsedMarkets = computed(() => {
            if (props.selectedOdds.size === 0) {
                return false;
            }
            if (!props.market) {
                return true;
            }
            return !props.market.odds.find((x) => props.selectedOdds.has(x.uuid));
        });

        const isLoadingMap = computed(() => {
            return props.market?.odds.reduce((acc, odd) => {
                acc[odd.id] = betslipStore.getter('isSubmittingOdd').value[odd.uuid];
                return acc;
            }, {} as Record<string, boolean>) ?? {};
        });

        const formatDisplayName = (odd: any) => {
            if (getPe131DescriptiveOddButtonVariant() !== PE131DescriptiveOddNameVariant.None) {
                return odd.description;
            }
            return odd.displayValue;
        };

        return {
            hasSelectionInCollapsedMarkets,
            isMobileLayout: computed(() => {
                return isMobileLayout();
            }),
            isLoadingMap,
            formatDisplayName,
            applyOddButtonOverrideStyle,
        };
    },
    components: {
        EventCardLabel,
        EventPin,
        OddButton,
    },
});
